import React from 'react';
import { Alert, Modal } from 'antd';

import { RecordIdentity } from '../common/RecordBadge';
import HistoryList from './HistoryList';

/**
 * A record's history in a modal — the door the ⋯ menus open on surfaces
 * that do not show the read view (list cards, table rows, the card form).
 * Leads with the record's identity block, like every modal that acts on a
 * record (platform standards § 7). `notice` is one line about the record's
 * state beneath it — a deleted item's history says it is deleted.
 */
export default function HistoryModal({ open, onClose, kicker, badge, notice = null, fetchPage, onReverted, canRevert = true }) {
	return (
		<Modal open={open} onCancel={onClose} footer={null} title="History" width={720} destroyOnClose>
			{badge ? (
				<div className="modal-identity">
					<RecordIdentity kicker={kicker} badge={badge} />
				</div>
			) : null}
			{notice ? <Alert className="history-modal__notice" type="info" showIcon message={notice} /> : null}
			{open ? <HistoryList fetchPage={fetchPage} onReverted={onReverted} canRevert={canRevert} /> : null}
		</Modal>
	);
}
